import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lC5w8"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("aFzkz"), parcelRequire.load("g56vt"), parcelRequire.load("fHoW9"), parcelRequire.load("euokj"), parcelRequire.load("3shle"), parcelRequire.load("j7ts3")]).then(() => {
  return Promise.all([waitForCSS("/Accordion.1e58f736.css")]);
}).then(() => {
let originalModule = parcelRequire("fxMzH");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("aFzkz")} />
  <link rel="modulepreload" href={parcelRequire.resolve("g56vt")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lC5w8")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("fHoW9")} />
  <link rel="modulepreload" href={parcelRequire.resolve("euokj")} />
  <link rel="modulepreload" href={parcelRequire.resolve("3shle")} />
  <link rel="modulepreload" href={parcelRequire.resolve("j7ts3")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
